import { useTranslation } from "react-i18next";
import type { ThreadState } from "../../../api/threads/threadDecoders";
import { classNames } from "../../../ui/styles/classNames";

interface ThreadConnectionSignProps {
  state: ThreadState;
  className?: string;
}

/**
 * Whether a Run is connected to the PC it runs on, as a small dot at the start of its row's second line: the connection
 * is no progress, so it is not the Run's badge (Johannes, 4 Nov 09:28). Filled while live, hollow while saved; a closed
 * Run runs nowhere and has none. Its words show on hover and to screen readers.
 */
export default function ThreadConnectionSign({ state, className }: ThreadConnectionSignProps) {
  const { t } = useTranslation();
  if (state === "closed") return null;
  return (
    <span className={classNames("inline-flex shrink-0 items-center", className)} title={t(`threads.connection.${state}.explanation`)}>
      <span
        aria-hidden="true"
        className={classNames("h-1.5 w-1.5 rounded-full", state === "live" ? "bg-[var(--app-success)]" : "border border-[var(--app-text-muted)]")}
      />
      <span className="sr-only">{t(`threads.connection.${state}.label`)}</span>
    </span>
  );
}
